import React, { use, useState } from 'react'
import toast from 'react-hot-toast'
import { data, Link, useNavigate } from 'react-router-dom'

export default function ForgetPassword1() {
  let[username,setUsername]=useState("")

  let [errorMessage,setErrorMessage]=useState({

    // password:"Password Field Is Required"
  })
  let [show,setShow]=useState(false)
  let navigate =useNavigate()
 
 function getInputData(e){
     setUsername(e.target.value)
     
 }

 async function postData(e) {
  e.preventDefault();

  try {
    const response = await fetch("http://34.228.14.188:8000/api/user/forget-password-1", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ username })
    });

    const result = await response.json();

    if (result.result === "Done") {
      localStorage.setItem("password-reset-admin", username);
      alert("Note: OTP sent to your email address")
      navigate("/forget2"); // Make sure this is the next intended step
      toast.success("OTP sent to your email address")
    } else {
      setShow(true);
      setErrorMessage(result.reason || "Something went wrong");
    }

  } catch (error) {
    console.error("POST error:", error);
    setShow(true);
    setErrorMessage("Server Error. Please try again.");
  }
}

  return (
    <>
        <div className="forget-pass-banner1">
            {/* <img src="/images/classicroom1.JPG" alt="" /> */}
        </div>

    <div className="container"> 
        <div className="main-forget">
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-6 col-sm-12 col-12 mt-3 forger-pass-left">
                    <img src="/images/forget-img.svg" alt="V_Hotel_the_grnad_shoba forget" title='V_Hotel_the_grnad_shoba Title' />

                </div>
                <div className="col-md-6 col-sm-12 col-12 mt-5 forger-pass-right">
                <h1 className="mb-2">Forgot your password ??</h1>
          <p className="text-muted mb-4">
            Please enter the email address you'd like your password reset information sent to.
          </p>

          <form onSubmit={postData}>
            <div className="mb-3 col-md-12 forget-password-input">
                {/* <p>Email or UserName</p> */}
              <input
                 type="text" name="username" onChange={getInputData}
                className="form-control"
                placeholder="Enter your email address Or UserName"
              />
              {show && errorMessage? <p className='text-danger'>{errorMessage}</p>:""}
            </div>
            <div className="mb-3 col-md-12 forget-btn  ">
              <button className="btn btn-primary w-100" type='submit'>Reset Your Password?</button>
            </div>
            <div className="mb-3 col-md-12 forget-bakcToLogin">
             <Link  to='/signin'>
               <span className='text-center'>Back to Login</span> 
             </Link>
             
            </div>
           
          </form>
         
        </div>
                </div>
            </div>
        </div>
        </div>
    
    </>
  )
}
